/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updatedRoom = /* GraphQL */ `
  subscription UpdatedRoom {
    updatedRoom {
      id
      sid
      started
      title
      user_id
      status
      type
      recorded
      scheduled
      processedRecordings {
        id
        pctDone
        secondsToDone
        room_sid
        duration
        status
        participant
      }
      rawRecordings {
        room_sid
        rec_sid
        participant_sid
        track_type
        offset
        duration
      }
    }
  }
`;
export const updatedSingleRoom = /* GraphQL */ `
  subscription UpdatedSingleRoom($id: ID!) {
    updatedSingleRoom(id: $id) {
      id
      sid
      started
      title
      user_id
      status
      type
      recorded
      scheduled
      processedRecordings {
        id
        pctDone
        secondsToDone
        room_sid
        duration
        status
        participant
      }
      rawRecordings {
        room_sid
        rec_sid
        participant_sid
        track_type
        offset
        duration
      }
    }
  }
`;
